var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "translate(11.328427, 10.671573) rotate(-45.000000) translate(-11.328427, -10.671573) ",
  x: 5.82842712,
  y: 9.17157288,
  width: 11,
  height: 3,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  transform: "translate(7.439340, 12.439340) rotate(-315.000000) translate(-7.439340, -12.439340) ",
  x: 4.43933983,
  y: 10.9393398,
  width: 6,
  height: 3,
  rx: 1
})))));
export default SvgCheck;